const AiBatchIntakeTestIdsScope = {
  AI_BATCH_INTAKE: 'ai-batch-intake',
};

export const AiBatchIntakeTestIds = {
  BROWSE_FILES_BUTTON: `${AiBatchIntakeTestIdsScope.AI_BATCH_INTAKE}.browse-files-button`,
  CANCEL_BUTTON: `${AiBatchIntakeTestIdsScope.AI_BATCH_INTAKE}.cancel-button`,
  COMPLETION_BANNER: `${AiBatchIntakeTestIdsScope.AI_BATCH_INTAKE}.completion-banner`,
  CONFIRM_AND_FILE_BUTTON: `${AiBatchIntakeTestIdsScope.AI_BATCH_INTAKE}.confirm-and-file-button`,
};
